import { Component, Inject, Input, OnInit } from '@angular/core';
import { ScreenTag } from 'libs/core/src/lib/model/screen-tag.model';
import { ScreenViewModel } from 'libs/core/src/lib/model/view-model/screen/screen.view.model';

@Component({
  selector: 'app-screen-movie-details',
  templateUrl: './movie-details.component.html',
  standalone: false
})
export class ScreenMovieDetailsComponent implements OnInit {
  @Input() model: ScreenViewModel;
  @Input() fields: string[] = [];
  @Input() screenTag: ScreenTag;
  @Input() separator: string = '/&nbsp;';

  displayItems: { key: string; values: string[] }[] = [];

  ngOnInit(): void {
    this.displayItems = [
      {
        key: 'moviePrintType',
        values: this.model?.moviePrintType?.split('/') || [],
        class: 'movie-print-type'
      },
      {
        key: 'movieSpeakingType',
        values: this.model?.movieSpeakingType?.split('/') || [],
        class: 'movie-subtitles'
      }
    ].filter((item) => this.fields.includes(item.key) && item.values.length > 0);
  }
}
